/* @flow strict */

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import Login from './login';
import CollaboratorSignUp from './collaboratorSignUp';
import Reset from './reset';
import HeaderHelper from './headerHelper';
import SignUp from './signUp';
import Resend from './resend';
import ConfirmEmail from './confirmEmail';
import Parallax from 'parallax-js';

import './styles.less';

type PropsType = {
  match: {
    path: string
  },
  history: {
    push: (string) => void
  },
  logout?: () => void
};

const AuthPage = (props: PropsType): React.Element<typeof React.Fragment> => {
  const { match: { path } } = props;
  const [view, _changeView] = React.useState(path);
  const ref = React.createRef();

  const changeView = (_view_: string) => {
    props.history.push(_view_);
    _changeView(_view_);
  };

  React.useEffect(() => {
    if (view === '/sign-up') {
      props.logout();
    }
  }, [view]);

  setTimeout(() => {
    const scene = ref.current;

    if (scene) {
      const parallaxInstance = new Parallax(scene, {
        relativeInput: true,
        clipRelativeInput: true,
        hoverOnly: true
      });

      parallaxInstance.friction(0.2, 0.2);
    }
  }, 500);

  return (
    <React.Fragment>
          <div
            className="sparxo-layout layout-auth collapsed AUTH"
          >
            <div ref={ref} data-hover-only="true" className='sparxo-layout-bg-wrapper'>
              <div
                className='sparxo-layout-bg'
                data-depth="0.1"
                data-hover-only="true"
              />
            </div>

            <div
              className="sparxo-pages sparxo-auth-pages"
            >
              <div className="sparxo-router-content">
                <div className="sparxo-page md-effect-15 md-show" data-animate="md-show">
                  <div className="md-content">
                    <div className="form-box">

                      <div className="auth-btn-redirect">
                        <HeaderHelper
                          view={view}
                          changeView={changeView}
                        />
                      </div>

                      <header className="form-box-header">
                        <div className="form-logo">
                          <span className="sparxo-logo1" />
                        </div>
                        <div className="form-title sparxo-logo1-text" />
                      </header>

                      {path === '/login' ?
                        <Login handleChangeView={changeView} {...props} /> :
                        null
                      }

                      {view === '/reset-password' ?
                        <Reset handleChangeView={changeView} {...props} /> :
                        null
                      }

                      {view === '/sign-up' ?
                        <SignUp handleChangeView={changeView} {...props} /> :
                        null
                      }

                      {view === '/resend-email' ?
                        <Resend handleChangeView={changeView} {...props} /> :
                        null
                      }

                      {view === '/confirm-email' ?
                        <ConfirmEmail handleChangeView={changeView} {...props} /> :
                        null
                      }
                      {path === '/account/active' ?
                        <CollaboratorSignUp handleChangeView={changeView} {...props} /> :
                        null
                      }
                    </div>

                    <div className="form-box-footer">
                      <div className="text-center">
                        &copy; {new Date().getFullYear()} Sparxo Inc. All Rights Reserved
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </React.Fragment>
  );
};

export default withRouter(AuthPage);
// export default Auth;
